import React from 'react';
import { Icon, UtilityText } from '@leagueplatform/genesis-core';

export interface ErrorWithIconProps {
  errorMessage: string;
}

export const ErrorWithIcon = ({ errorMessage }: ErrorWithIconProps) => (
  <UtilityText
    size="sm"
    css={{
      display: 'flex',
      alignItems: 'center',
      marginTop: '$threeQuarters',
      color: '$onSurfaceTextCritical',
      gap: '0.5ch',
    }}
    role="alert"
  >
    <Icon icon="statusErrorStatusFilled" size="1em" />
    {errorMessage}
  </UtilityText>
);
